import React from 'react'
import Footer from '../Footer'
import Header from '../Header'

const Layout = ({ showFooter = true, children }) => {
  return (
    <>
      <Header />
      <main>{children}</main>
      {showFooter && <Footer />}
    </>
  )
}

export default Layout
